var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.cards_works),function(card,index){return _c('b-col',{key:index,staticClass:"col-12 col-md-6 d-flex align-items-stretch mb-1"},[_c('card-work',{attrs:{"data":card},on:{"click_action":_vm.redirectAction}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }